<template>
  <div
    class="modal fade"
    :id="`plans-modal-${item.id}`"
    tabindex="-1"
    role="dialog"
    aria-labelledby="shareModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog  modal-dialog-centered"
      role="document"
    >
      <div class="modal-content">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          @click="onCloseModal()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <div class="plans-description">
            <span class="icon-lock">
              <i class="fas fa-lock"></i>
            </span>
            <h1 class="item-name">
              {{ item.name }}
            </h1>
            <span class="request"> Please pay to watch </span>
          </div>
          <div
            class="plans-modal__content"
            v-if="loading"
          >
            <div
              class="plan-modal-skeleton"
              v-for="index in 2"
              :key="index"
            ></div>
          </div>

          <div
            class="plans-modal__content"
            v-else
          >
            <div
              class="plans-modal__content__body__plans__item"
              v-for="(plan, index) in plans"
              :key="index"
            >
              <planBg />
              <div class="plan-details">
                <div class="plans-modal__content__body__plans__item__title">
                  <h1>{{ plan?.name }}</h1>
                </div>
                <div class="plans-modal__content__body__plans__item__price">
                  <h2>{{ getActualPrice(plan) }}</h2>
                </div>
                <div class="plans-modal__content__body__plans__item__button">
                  <button
                    class="btn"
                    @click="handlePayment(plan)"
                  >
                    Pay Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import planBg from './plan-bg.vue';
export default {
  name: 'PlansModal',
  components: {
    planBg,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    single: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      plans: [],
      loading: true,
    };
  },
  mounted() {
    this.handleGetAllPlan();
  },
  methods: {
    onCloseModal() {
      this.$emit('closeModal');
    },

    async handleGetAllPlan() {
      this.loading = true;
      var url = `/user/filtered-plans?flix_playlist_id=${this.item.id}`;
      if(this.single) {
        url = `/user/filtered-plans?item_id=${this.item.id}`;
      }
      try {
        const response = await axios.get(url);
        const {
          data: { data },
        } = response;
        this.loading = false;
        this.plans = data.plans.data;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async handlePayment(plan) {
      const url = `/user/subscribe-plan`;
      const data = {
        id: plan.id,
        _token: window.csrfToken,
      };

      try {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = url;
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
          }
        }
        document.body.appendChild(form);
        form.submit();
      } catch (error) {
        console.log(error.message);
      }
    },

    getActualPrice(plan) {
      var currency = 'RWF';
      return `${currency} ${+plan.pricing}`;
    },
  },
};
</script>

<style scoped>
.plans-modal__content {
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-gap: 10px;
}
.plans-modal__content__body__plans__item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 20px;
  position: relative;
  border-radius: 10px;
  width: 100%;
  height: 200px;
  max-height: 200px;
}

@media screen and (max-width: 768px) {
  .plans-modal__content__body__plans__item {
    height: unset;
    max-height: unset;
    margin-bottom: 0px;
    padding: 30px;
  }
}

.plans-description {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 10px;
}
.icon-lock {
  font-size: 30px;
  color: #fff;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;

  i {
    z-index: 2;
  }
}

.icon-lock::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 60px;
  height: 60px;
  background: #252727bd;
  border-radius: 50%;
  z-index: 1;
}

.item-name {
  color: #fff;
  font-size: 20px;
  font-weight: bolder;
}
.request {
  color: #6c757d;
  font-size: 16px;
  font-weight: 700;
}
.close {
  color: #fff;
  font-size: 30px;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  background-color: #00000063;
  border-radius: 50%;
  width: 40px;
  height: 40px;
}
.plan-details {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.plans-modal__content__body__plans__item__title {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;

  h1 {
    font-size: 30px;
    font-weight: 900;
  }
}
.plans-modal__content__body__plans__item__price {
  color: #fff;
  margin-bottom: 10px;

  h2 {
    font-size: 20px;
    font-weight: 900;
  }
}
.plans-modal__content__body__plans__item__button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  color: #0000;
  border-radius: 30px;
  transition: 0.3s;
  transition-timing-function: ease-in-out;
  padding: 0 20px;
  font-weight: 900;
}

@media (max-width: 567px) {
  .plans-modal__content__body__plans__item__price {
    color: #fff;
    margin-bottom: 10px;

    h2 {
      font-size: 15px;
      font-weight: 900;
    }
  }

  .plans-modal__content__body__plans__item__title {
    margin-bottom: 10px;

    h1 {
      font-size: 20px;
      font-weight: 900;
    }
  }
}
.plan-modal-skeleton {
  background: #535353;
  border-radius: 10px;
  width: 100%;
  height: 200px;
  max-height: 200px;
  position: relative;
  z-index: 1;
  overflow: hidden;
}
</style>
